import { Input, Text } from 'components/ui';
import { CharactersRemainingInput } from 'components/ui/input/characters-remaining-input';
import { FC } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import styled from 'styled-components';
import { SendBroadcastDialogForm } from '..';

const Container = styled.div`
  display: grid;
  gap: 20px;
`;

const InputsContainer = styled.div`
  display: grid;
  gap: 10px;
`;

export interface SendBroadcastInputStepProps {}

export const SendBroadcastInputStep: FC<SendBroadcastInputStepProps> = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<SendBroadcastDialogForm>();
  const message = useWatch({ name: 'message' });

  return (
    <Container>
      <Text>Seller's watching this price will receive this message.</Text>
      <InputsContainer>
        <CharactersRemainingInput
          label='Message'
          as='textarea'
          maxLength={500}
          value={message}
          state={errors.message && 'error'}
          message={errors.message?.message}
          {...register('message')}
        />
        <Input
          {...register('link')}
          state={errors.link && 'error'}
          message={errors.link?.message}
          label={
            <>
              Include a link{' '}
              <Text fontWeight='regular' as='span'>
                (optional)
              </Text>
            </>
          }
        />
      </InputsContainer>
    </Container>
  );
};
